export default __webpack_public_path__ + "static/media/mobile-timeline.b3c3710e.svg";